import { j as w } from "./jsx-runtime.DGlMoOmv.js";
import { c as a } from "./index.CxSWpsOB.js";
const i = ({
  size: t,
  className: e,
  appearance: r,
  testId: b = "spinner",
  ...o
}) => /* @__PURE__ */ w.jsx("span", { className: a("tw-inline-block tw-rounded-circular tw-border-2 tw-border-r-transparent tw-border-l-base-white tw-border-t-base-white tw-border-b-base-white tw-size-[14.5px] tw-animate-spin", {
  "tw-size-[18.5px]": t === "large",
  "tw-border-l-gray-900 tw-border-t-gray-900 tw-border-b-gray-900": r === "black",
  "tw-border-l-purple-600 tw-border-t-purple-600 tw-border-b-purple-600": r === "purple",
  "tw-border-l-gray-300 tw-border-t-gray-300 tw-border-b-gray-300": r === "gray"
}, e), "data-testid": b, ...o });
export {
  i as S
};
//# sourceMappingURL=Spinner.Brgz0Lk4.js.map
